import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const faqItems = [
  {
    question: 'What is Viva?',
    answer:
      'Viva is a fully autonomous platform designed to streamline digital marketing, blockchain operations, and cryptocurrency trading. It leverages cutting-edge AI to automate tasks, making independent decisions to optimize your campaigns, blockchain launches, and trading strategies.',
  },
  {
    question: 'How does autonomous marketing work on Viva?',
    answer:
      'Viva’s autonomous marketing tools analyze market trends and consumer behavior to create, launch, and optimize campaigns without manual intervention. The platform continuously learns and adapts to improve engagement and conversion rates.',
  },
  {
    question: 'What blockchain operations can Viva handle?',
    answer:
      'Viva automates key blockchain operations including launching tokens, creating liquidity pools, conducting airdrops, and managing presales. This ensures seamless, decentralized, and efficient blockchain management.',
  },
  {
    question: 'How does autonomous cryptocurrency trading work?',
    answer:
      'Viva employs sophisticated trading algorithms for autonomous cryptocurrency trading. It conducts real-time portfolio analysis, manages risks, and executes trades to optimize returns without the need for constant human oversight.',
  },
  {
    question: 'Is Viva secure?',
    answer:
      'Security is a top priority at Viva. The platform uses robust encryption and privacy protocols, ensuring that your data and transactions are safeguarded at all times.',
  },
  {
    question: 'How do I get started with Viva?',
    answer:
      'Getting started with Viva is easy. Simply sign up, connect your preferred tools and wallet, and follow our guided onboarding process to start automating your marketing, blockchain operations, and trading strategies.',
  },
];

export default function FAQ() {
  return (
    <Box
      id="faq"
      sx={{
        width: '100%',
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        backgroundColor: 'background.paper',
      }}
    >
      <Container>
        <Typography
          component="h2"
          variant="h4"
          sx={{
            fontWeight: 700,
            textAlign: 'center',
            marginBottom: 4,
            color: 'text.primary',
          }}
        >
          Frequently Asked Questions
        </Typography>
        {faqItems.map((item, index) => (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
            >
              <Typography sx={{ fontWeight: 400 }}>
                {item.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
                {item.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </Box>
  );
}